import { createApp } from 'vue'
import SearchSection from './SearchSection.vue'
import { createPinia } from 'pinia'
const pinia = createPinia()

createApp(SearchSection)
    .use(pinia)
    .mount('#search-section')
